
import React from 'react';
import { Link } from 'react-router';
import Logo from './Logo';
import { trackEvent } from './analytics';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-950 border-t border-white/5 py-16 px-4">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="space-y-6">
          <Link to="/">
            <Logo size="sm" />
          </Link>
          <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
            Next-generation enterprise aviation platform empowering CAAs and ANSPs with digital precision and compliance.
          </p>
          <div className="flex space-x-4">
            <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent/20 cursor-pointer transition-colors">
              <span className="text-xs text-slate-400 font-bold" onClick={() => {
    window.open("https://www.linkedin.com/company/flyclim/", "_blank", "noopener,noreferrer");
  }}>in</span>
            </div>
            {/* <div className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-accent/20 cursor-pointer transition-colors">
              <span className="text-xs text-slate-400 font-bold">X</span>
            </div> */}
          </div>
        </div>

        <div>
          <p className="text-white font-bold mb-6">Modules</p>
          <ul className="space-y-4 text-sm text-slate-400">
            <li><Link to="/modules/eaip" className="hover:text-accent transition-colors">eAIP Digital Platform</Link></li>
            <li><Link to="/modules/sms" className="hover:text-accent transition-colors">Safety Management</Link></li>
            <li><Link to="/modules/lms" className="hover:text-accent transition-colors">Training & LMS</Link></li>
            <li><Link to="/modules/pans-ops" className="hover:text-accent transition-colors">PANS-OPS Design</Link></li>
            <li><Link to="/modules/utm" className="hover:text-accent transition-colors">UTM Governance</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-white font-bold mb-6">Resources</p>
          <ul className="space-y-4 text-sm text-slate-400">
            <li><Link to="/solutions" className="hover:text-accent transition-colors">Solutions</Link></li>
            <li><Link to="/compliance" className="hover:text-accent transition-colors">Compliance Framework</Link></li>
            <li><Link to="/sms-regulatory" className="hover:text-accent transition-colors">SMS Regulatory</Link></li>
            <li><Link to="/sms-airlines" className="hover:text-accent transition-colors">SMS for Airlines</Link></li>
            <li><Link to="/lms-aviation-authority" className="hover:text-accent transition-colors">LMS for Authorities</Link></li>
            <li><Link to="/safety-governance" className="hover:text-accent transition-colors">Safety Governance</Link></li>
            <li><Link to="/team" className="hover:text-accent transition-colors">Team</Link></li>
            <li><Link to="/contact" className="hover:text-accent transition-colors" onClick={() => trackEvent('demo_request', { form_id: 'footer_request_demo' })}>Request a Demo</Link></li>
            <li><Link to="/public-portal" className="hover:text-accent transition-colors" onClick={() => trackEvent('demo_request', { form_id: 'footer_public_portal_demo', module: 'lms' })}>Public Portal Demo</Link></li>
            <li><Link to="/news" className="hover:text-accent transition-colors">News</Link></li>
            <li><Link to="/blog" className="hover:text-accent transition-colors">Aviation Insights</Link></li>
          </ul>
        </div>

        <div>
          <p className="text-white font-bold mb-6">Contact</p>
          <ul className="space-y-4 text-sm text-slate-400">
            <li>sales@aviagov.com</li>
            <li>+971 561722090</li>
            <li>+44 7456456668</li>
            <li>
              <span className="block text-white font-bold mb-1">AviaGov Address</span>
              Meydan Grandstand, 6th floor, Meydan Road, Nad Al Sheba, Dubai, U.A.E
            </li>
            <li>
              <span className="block text-white font-bold mb-1">Trade License</span>
              AviaGov LLC-FZ Trade License No. 2648161.01
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center text-xs text-slate-400 space-y-4 md:space-y-0">
        <p>&copy; {new Date().getFullYear()} AviaGov LLC-FZ. Trade License No. 2648161.01. All rights reserved.</p>
        <div className="flex space-x-6">
          <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-white">Terms of Service</Link>
          <Link to="/cookies" className="hover:text-white">Cookie Settings</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
